module.exports = __webpack_public_path__ + "static/media/warehouse.f08cbfe4.jpg";